export default {"src":"/_next/static/media/img-about-journey.c0b43bf0.svg","height":97,"width":126,"blurWidth":0,"blurHeight":0};